/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	useGetUserDetailsQuery,
	useLazyGetUserSignatureQuery,
} from '@/features/user/userApi';
import ToolbarDropdown from './ToolbarDropdown';
import { applySignatureStyles, EMPTY_HTML } from '@/utils/emailHelper';

const UserSignatureDropdown = ({ onChange }) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery(
		{ email },
		{ skip: !email }
	);
	const [getUserSignature] = useLazyGetUserSignatureQuery();

	const fields = useMemo(() => {
		const signatures =
			userDetails?.emailSignatures ??
			(userDetails?.signatureHtmlUrl
				? [
					{
						name: 'Default signature',
						signature: userDetails.signatureHtmlUrl,
					},
				  ]
				: []);

		return signatures.map((sig) => ({
			label: sig.name,
			value: sig.name,
			url: sig.signature,
		}));
	}, [userDetails]);


	const getNodeValue = async (event) => {
		const field = fields.find((v) => v.value === event.target.value);
		if (!field?.url) return;

		const html = await getUserSignature({ url: field.url }).unwrap();
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;

		const el = tempDiv.querySelector('[data-signature="true"]');
		if ((el?.tagName ?? '').toLowerCase() === 'div') {
			applySignatureStyles(el);
		}

		onChange(tempDiv.innerHTML);
	};


	return (
		<ToolbarDropdown
			title="email signatures"
			fields={fields}
			onChange={getNodeValue}
		/>
	);
};

export default UserSignatureDropdown;
